import styled from '@emotion/styled'
import { baseLayout } from '../../constants/theme'

export const Footer = styled('div')(({ collapsed, theme, isAssistino }) => ({
  position: isAssistino ? 'fixed' : 'absolute',
  bottom: isAssistino ? 0 : 'auto',
  zIndex: isAssistino ? 1000 : 'auto',
  left: collapsed
    ? `${baseLayout.sidebarCollapsedWidth} !important`
    : baseLayout.sidebarWidth,
  padding: `calc(${baseLayout.gridGutterWidth})`,
  right: '0',
  color: baseLayout.brandColorOrange,
  height: baseLayout.footerHeight, // `calc(${theme.footerHeight} - 20px)`,
  backgroundColor: theme.mainContentBg,
  textAlign: 'center',
  fontSize: '12px',
  [`@media (max-width: ${baseLayout.mobileBreakpoint}px)`]: {
    left: '0 !important',
    right: '0 !important',
  },
  '@media print': {
    display: 'none !important',
  },
}))

export const FooterContent = styled('span')(({ theme }) => ({
  color: theme.footerSpanColor,
}))
